import { useListPager } from '@airship-platform/airship-patterns';
import {
  PriceSectionEditable,
  Product,
  ProductCard,
} from '@airship-platform/airship-proposal';
import { FlexBox } from '@airship-platform/jam-web/components';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import { useSearchParams } from 'react-router';
import EquipmentListActionButtons from './EquipmentListActionButtons';

interface EquipmentListViewProps {
  products: Product[];
  pageSize: number;
  onPageSizeChange: (newFilter: Partial<{ pageSize: number }>) => void;
}

const EquipmentListView: React.FC<EquipmentListViewProps> = ({
  products,
  pageSize,
  onPageSizeChange,
}) => {
  const [searchParams] = useSearchParams();
  const { loaderRef } = useListPager({
    incrementBy: 20,
    initialValue: pageSize,
    maxValue: products.length,
    callbackFn: (newPageSize) => {
      onPageSizeChange({ pageSize: newPageSize });
    },
  });

  const replaceProductId = searchParams.get('replaceProductId');
  const itemGroupRootId = searchParams.get('itemGroupRootId');
  const pagedProducts = products.slice(0, pageSize);

  return (
    <FlexBox flexDirection={'column'} gap={3}>
      {pagedProducts.map((product) => (
        <FlexBox flexDirection={'column'} gap={2} key={product.pricebookId}>
          <ProductCard
            product={product}
            productClickRoute={
              replaceProductId || itemGroupRootId
                ? undefined
                : product.pricebookId
            }
            priceSection={
              <PriceSectionEditable
                prices={product.prices}
                defaultPriceType={product.defaultPriceType}
              />
            }
            productNameSuffix={
              <Box sx={{ display: 'inline-block' }}>
                {!!product.matchesCertifications && (
                  <Chip color="gold" label="AHRI match" size="small" />
                )}
              </Box>
            }
          >
            <EquipmentListActionButtons
              product={product}
              replaceProductId={replaceProductId}
              itemGroupRootId={itemGroupRootId}
            />
          </ProductCard>
          <Divider
            sx={{
              display: ['block', 'none'],
            }}
          />
        </FlexBox>
      ))}
      <Box
        ref={loaderRef}
        sx={{
          height: 50,
        }}
      />
    </FlexBox>
  );
};

export default EquipmentListView;
